import { Reveal } from "@/components/site/Reveal";
import { ArrowUpRight, Phone, NavigationArrow } from "@phosphor-icons/react";
import { trackEvent } from "@/lib/api";

export function ContactCTA() {
  const go = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  return (
    <section id="contact" className="py-24 md:py-32 scroll-mt-20">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal>
          <div className="relative overflow-hidden rounded-[2rem] bg-[#0A192F] text-white grain px-8 py-16 md:p-20">
            <div className="relative max-w-3xl">
              <span className="label text-white/50">Contact</span>
              <h2 className="font-display text-4xl sm:text-6xl tracking-tight leading-[1.05] mt-4">
                Have a question or need to schedule a consultation?
              </h2>
              <div className="mt-10 flex flex-wrap gap-3">
                <button
                  onClick={() => go("appointment")}
                  data-testid="cta-request-appointment"
                  className="btn-accent inline-flex items-center gap-2 rounded-full px-6 py-3.5 font-semibold transition-[transform,background-color] duration-300"
                >
                  Request an Appointment <ArrowUpRight size={18} weight="bold" />
                </button>
                <button
                  onClick={() => { trackEvent("phone_clicked"); go("appointment"); }}
                  data-testid="cta-contact-clinic"
                  className="inline-flex items-center gap-2 rounded-full border border-white/25 text-white px-6 py-3.5 hover:border-white/60 transition-colors"
                >
                  <Phone size={18} weight="duotone" /> Contact the Clinic
                </button>
                <a
                  href="https://www.google.com/maps/search/?api=1&query=SGRR+Medical+College+and+Hospital+Dehradun"
                  target="_blank" rel="noopener noreferrer"
                  onClick={() => trackEvent("directions_clicked")}
                  data-testid="cta-directions"
                  className="inline-flex items-center gap-2 rounded-full border border-white/25 text-white px-6 py-3.5 hover:border-white/60 transition-colors"
                >
                  <NavigationArrow size={18} weight="bold" /> Get Directions
                </a>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
